import { csl, u_ } from "@pressmedia/webappbase";
const { app } = window;

export default {
	_contentKey: null,
	
	/**
	 * 現在のコンテンツ識別子を取得
	 * @returns
	 */
	getContentKey() {
		return this._contentKey;
	},
	
	/**
	 * 現在のコンテンツ識別子の更新
	 * @param {String} contentKey
	 * @returns {Boolean} modulenのdataKeyが更新されたかどうか
	 */
	setContentKey(contentKey) {
		u_.isString(contentKey) || (contentKey = "");
		
		let rtn = false;
		const isWaitingLogin = app.isWaitingLogin();
		const container = this.get("pageMain") || this.get("body");
		
		if(
			!contentKey ||
			contentKey === "login" ||
			!u_.hasProperty(app.config.dataItems, contentKey)
		) {
			// [contentKeyが空 | login | データ名では無い場合]
			if( !isWaitingLogin ) {
				// ログイン待ちで無ければコールバックを実行して終了
				if( u_.isFunction(app.onChangeContentKey) ) {
					this.promise = Promise.all([
						app.onChangeContentKey(contentKey, this._contentKey)
					]);
				}
			} else {
				// ログイン待ちの場合、is-refreshingクラスを削除
				container.$self.removeClass("is-refreshing");
			}
			
		} else
		if( contentKey !== app.module.getDataKey() ) {
			// [moduleのdataKeyと異なる場合]
			rtn = true;
			
			if(!isWaitingLogin) {
				// ログイン待ちでなければmoduleのメンバ変数を初期化
				app.module.config = {};
				app.module.getFilter = {};
				
				if( u_.isObject(app.sortDefault[contentKey]) ) {
					// デフォルトのソート設定がなされていれば反映
					app.module.getFilter.sort = app.sortDefault[contentKey];
				}
				
				// 生成されたdatePickerを削除
				this.get("body").$self.children(".Zebra_DatePicker").remove();
			}
			
			// load config
			container.$self.addClass("is-refreshing");
			this.promise = this._loadModuleConfig(
				contentKey,
				u_.isFunction(app.onChangeContentKey) && ((dataKey, config, res) => {
					const lastKey = this._contentKey;
					return app.onChangeContentKey(dataKey, lastKey, config, res);
				})
			);
			
			this.promise.then(() => container.$self.removeClass("is-refreshing"));
		}
		
		this._contentKey = contentKey;
		return rtn;
	},
	
	/**
	 * app.moduleの設定をロード
	 * @param {String} dataKey: データ識別子
	 * @param {Function} [callback]: コールバック
	 * @returns Promise
	 */
	_loadModuleConfig(dataKey, callback) {
		// set data key
		app.module.setDataKey(dataKey);
		
		return app.module.loadConfig(async (err, response) => {
			if(err) {
				app.module.setDataKey("");
				return false;
			}
			
			app.module.template = response.template;
			
			// execute loadConfigCallbacks
			if( u_.isFunction(app.loadConfigCallbacks[dataKey]) ) {
				const res = await app.loadConfigCallbacks[dataKey].call(
					app, app.module, response
				);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.loadConfigCallbacks.always) ) {
				const res = await app.loadConfigCallbacks.always.call(
					app, app.module, response
				);
				if(res === false) {
					return res;
				}
			}
			
			// refresh childSections
			const methods = [];
			this.childSections.forEach(v => {
				const vuw = this.get(`${v}Section`);
				if( vuw && u_.isFunction(vuw.refresh) ) {
					methods.push( vuw.refresh() );
				}
			});
			await Promise.all(methods).catch(
				(...errors) => csl.warn("The errors is catched.", ...errors)
			);
			
			// execute callback
			if( u_.isFunction(callback) ) {
				const res = await callback(
					dataKey, app.module.config, response
				);
				if(res === false) {
					return res;
				}
			}
			
			return true;
		});
	}
};
